export default __webpack_public_path__ + "fc770be435a307032ce04804635a3164.mp3";